import { IS_NATIVE } from './platform.util';

let _splash: any | null = null;

async function getSplash() {
  if (!IS_NATIVE) return null;
  if (_splash) return _splash;

  try {
    const mod = await import('@capacitor/splash-screen');
    _splash = mod.SplashScreen;
    return _splash;
  } catch {
    return null;
  }
}

export async function splashHide(): Promise<void> {
  const splash = await getSplash();
  await splash?.hide().catch(() => {});
}

export async function splashShow(): Promise<void> {
  const splash = await getSplash();
  await splash?.show().catch(() => {});
}
